import { render, staticRenderFns } from "./AdminAboutUs.vue?vue&type=template&id=1aa0f800&scoped=true"
import script from "./AdminAboutUs.vue?vue&type=script&lang=js"
export * from "./AdminAboutUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa0f800",
  null
  
)

export default component.exports